import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const helpers = createMultiStyleConfigHelpers([
  'container',
  'character',
  'characterInactive',
  'characterSelected',
  'characterFilled',
]);

const baseStyle = (theme: ThemesKeys) => ({
  character: {
    border: 'none',
    fontSize: getThemes(theme).fontSizes.xl,
    borderRadius: getThemes(theme).radii.lg,

    color: getThemes(theme).colors.palette.primary[0],
    backgroundColor: getThemes(theme).colors.palette.primary[100],
    boxShadow: `0px 0px 1px 1px ${getThemes(theme).colors.palette.neutral[60]}`,
  },

  characterSelected: {
    outline: `2px solid ${getThemes(theme).colors.palette.primary[50]}`,
  },
});

const sm = (theme: ThemesKeys) => ({
  character: {
    fontSize: getThemes(theme).fontSizes['lg'],
    lineHeight: '35px',
  },
  container: {
    width: '230px',
    height: '35px',
  },
});

const md = () => ({});

const lg = (theme: ThemesKeys) => ({
  character: {
    fontSize: getThemes(theme).fontSizes['4xl'],
    lineHeight: '70px',
  },
  container: {
    width: '370px',
    height: '70px',
  },
});

const sizes = (theme: ThemesKeys) => ({
  sm: sm(theme),
  md: md(),
  lg: lg(theme),
});

const CodeVerifyTheme = (theme: ThemesKeys) =>
  helpers.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    sizes: sizes(theme),
  });

export default CodeVerifyTheme;
